import { useTranslation } from 'react-i18next';
import { Checkbox } from 'Components';
import { useFormikContext } from 'formik';
import { AddGroupValues } from 'Pages/Group/Group.types';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

function EmailActivationField() {
	const { t } = useTranslation();
	const { setFieldValue } = useFormikContext<AddGroupValues>();

	return (
			<Checkbox.FormikField name="resendActivationEmail"
			onChange={(e: CheckboxChangeEvent) => {
				if (e.target.checked) {
					setFieldValue('autoactivate', false);
					setFieldValue('sso', false);
				}
			}}>
				{t(`users.components.resendActivationEmail.resendText`)}
			</Checkbox.FormikField>
	);
}

export default EmailActivationField;
